import { FC, PropsWithChildren, useMemo } from 'react';

import { CORE_ICONS } from '~/core/shared/assets';
import { IconRepository } from '~/core/shared/types';
import { IconRepositoryContext } from './IconRepositoryContext';

type Props = PropsWithChildren<{ icons?: Partial<IconRepository> }>;

export const IconRepositoryProvider: FC<Props> = ({ icons, children }) => {
  const value = useMemo(
    () => ({
      iconRepository: { ...CORE_ICONS, ...icons } as IconRepository,
    }),
    [icons],
  );

  return (
    <IconRepositoryContext.Provider value={value}>
      {children}
    </IconRepositoryContext.Provider>
  );
};
